import $ from 'jquery';
import modaal from 'modaal';
import Cookies from 'js-cookie';

class CardWidgetModal {
    constructor() {
        this.currentForm = null;
    }

    init() {
        this.handleCardModalBehavior();
    }

    handleCardModalBehavior() {
        if ($('.card-modal').length === 0 || $('.card-modal') === null) return;

        // Card Link Click Event
        $('.card-modal').on('click', (e) => {
            let cookie = Cookies.get('resourcelead');
            let modal = $(e.currentTarget).children('.lead-modal-modaal');
            let form = $(e.currentTarget).find('.lead-modal-form');

            if (form.length > 0) {
                this.currentForm = form;
            }

            // Check cookie - Will stop propagation if the cookie exists.
            if (cookie) {
                e.stopImmediatePropagation();
                e.preventDefault();
                const documentLink = form.attr('data-document');
                this.handleDownloadFile(documentLink, false);
                return;
            }

            // Init Modal
            $(e.currentTarget).modaal({
                content_source: modal,
                width: 532,
                custom_class: 'lead-modal',
                hide_close: true,
                start_open: true,   
                overlay_close: true,
            }); 
        });

        // Close Modal Event
        $('.lead-modal-close').click(() => {
            $('.card-modal').modaal('close');
        });
        
        // Form Submit Event
        $(document).on('submit', '.modaal-wrapper', (e) => {
            this.handleFormSubmit(e);
        });
    }

    handleFormSubmit(e) {
        e.preventDefault();
        $('.error-message').hide();

        const form = $(e.target);
        const button = form.find('button');
        const emailPattern = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(form.find('#Email').val())) {
            form.find('#Email').addClass('is-invalid');
            form.find('.error-message').text('Please enter a valid email address.').show();
            return;
        } else {
            form.find('#Email').removeClass('is-invalid');
        }
       
        // Disable submit button
        $(button).prop('disabled', true);

        // Get form data
        const documentLink = form.attr('data-document');
        const formData = {
            fullName: form.find('#fullName').val(),
            organization: form.find('#organization').val(),
            jobTitle: form.find('#jobTitle').val(),
            email: form.find('#Email').val(),
            documentName: form.attr('data-document-name')
        };

        // Ajax Call
        $.ajax({
            url: '/api/resourcelead/savelead',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(formData), 
            success: (result) => {
                if (result === true) {    
                    // Success
                    $('.modal-main-content').hide();
                    $('.success-message').show();
                    Cookies.set('resourcelead', 1, { expires: 30 });
                    this.handleDownloadFile(documentLink);
                    $(button).prop('disabled', false);
                } else {             
                    // Error
                    $('.error-message').show();
                    $(button).prop('disabled', false);
                }
            },
            error: () => {
                $('.error-message').show();
                $(button).prop('disabled', false);
            }
        });
    }

    handleDownloadFile(documentLink, isDownload = true) {
        // Handle 'Download File' Behavior
        const a = document.createElement('a');
        a.href = `${window.location.origin}${documentLink}`;
        a.target = '_blank';       
        if (isDownload) a.download = true;
        a.click();
    }    
}

export default CardWidgetModal;

$(() => {
    const cardWidgetModal = new CardWidgetModal();
    cardWidgetModal.init();
});